import state from "./state";
import actions from './actions';
import mutations from './mutations';

const scheduleDetailData = {
  namespaced: true,
  state,
  mutations,
  actions,
}
export default scheduleDetailData;